var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconProfile = function SvgIconProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC600",
    d: "M31.523 25.477v-2.954h-6.046v-6.046h-2.954v6.046h-6.046v2.954h6.046v6.046h2.954v-6.046h6.046ZM34.477 10.5c.796 0 1.5.305 2.109.914.61.61.914 1.313.914 2.11v20.953c0 .797-.305 1.5-.914 2.109-.61.61-1.313.914-2.11.914H13.524c-.843 0-1.57-.281-2.18-.844a3.103 3.103 0 0 1-.843-2.18V13.524c0-.843.281-1.546.844-2.109.61-.61 1.336-.914 2.18-.914h20.953Z"
  })));
};
export default SvgIconProfile;